export const CHANGEDRAWER = 'CHANGEDRAWER'
export const SET_EMAIL_ITEM = 'SET_EMAIL_ITEM'
export const SET_MENU = 'SET_MENU'
export const SET_GROUP_BRANCH = 'SET_GROUP_BRANCH'
export const SET_GROUP_SERVICE = 'SET_GROUP_SERVICE'
export const SET_SFTP_PAYLOAD = 'SET_SFTP_PAYLOAD'
export const SET_SFTP_PAGE = 'SET_SFTP_PAGE'
export const SET_SFTP_SELECT = 'SET_SFTP_SELECT'
// เช็คการล็อกอิน
export const AUTH_PORTAL_CHECK = 'AUTH_PORTAL_CHECK'
export const AUTH_PORTAL_SUCCESS = 'AUTH_PORTAL_SUCCESS'
export const AUTH_PORTAL_EXPIRED = 'AUTH_PORTAL_EXPIRED'

// เช็คการล็อกอินเผื่อดึงข้อมูล
export const ACCOUNT_PORTAL_CHECK = 'ACCOUNT_PORTAL_CHECK'
export const ACCOUNT_PORTAL_SUCCESS = 'ACCOUNT_PORTAL_SUCCESS'
export const ACCOUNT_PORTAL_NOTFOUND = 'ACCOUNT_PORTAL_NOTFOUND'

// เช็คการ SingleSignOn
export const CENTRESSO_PORTAL_REQUEST = 'CENTRESSO_PORTAL_REQUEST'
export const CENTRESSO_PORTAL_SUCCESS = 'CENTRESSO_PORTAL_SUCCESS'
export const CENTRESSO_PORTAL_NOTFOUND = 'CENTRESSO_PORTAL_NOTFOUND'

// เช็ค
// export const ACCOUNTPAYMENT_PORTAL_CHECK = 'ACCOUNTPAYMENT_PORTAL_CHECK'
// export const ACCOUNTPAYMENT_PORTAL_REQUEST = 'ACCOUNTPAYMENT_PORTAL_REQUEST'
// export const ACCOUNTPAYMENT_PORTAL_SUCCESS = 'ACCOUNTPAYMENT_PORTAL_SUCCESS'
// export const ACCOUNTPAYMENT_PORTAL_NOTFOUND = 'ACCOUNTPAYMENT_PORTAL_NOTFOUND'


// WEBPACK FOOTER //
// ./src/store/mutation-types.js